import _ from 'lodash';

import axios from '~/constants/axiosConfig';
import { getQueryString } from '~/helpers/functions';

export default async function getTemplates(filtro) {
  let route = 'Template';

  if (!_.isEmpty(filtro)) {
    route += getQueryString(filtro);
  }

  return axios.get(route).then((response) => {
    const { status, data } = response;

    if (status === 200) {
      return data.resultados;
    }
    return [];
  });
}
